import React, {
  useState,
  useEffect,
  useMemo,
} from 'react';
import {
  Row,
  Col,
  Button,
  Input,
} from 'antd';
import { useHistory } from 'react-router-dom';
import {
  axiosAuthInstance,
  API_END_POINTS
} from '../../../../../api';
import { SpText } from '../../../../../components/DesignKit';
import { PAGES } from '../../../../../appconstants';
// import formatAmount from '../../../../../utils/formatAmount';

type Props = {
  userSetAmount: String,
  currencyType: String,
  notes: String,
  shopEntity: Object,
  isShopOpen: Boolean,
  handlePaymentPortalInfo: Function,
  setMessageModalVisible: Function,
  setStatusModalMessage: Function,
  redirectUrl: String,
  slugName: String,
  setIsProfileVisible: Function,
  paymentAtStoreData: Function,
  buttonStyle: Object,
  setPaymentPortalModal: Function,
};

const PayScreen = (props: Props) => {
  const {
    userSetAmount,
    currencyType,
    notes,
    shopEntity,
    isShopOpen,
    handlePaymentPortalInfo,
    setMessageModalVisible,
    setStatusModalMessage,
    redirectUrl,
    slugName,
    setIsProfileVisible,
    paymentAtStoreData,
    buttonStyle,
    setPaymentPortalModal,
  } = props;

  const history = useHistory();
  const [promoCode, setPromoCode] = useState('');
  const [promoMessage, setPromoMessage] = useState('');
  // const [customTipAmount, setCustomTipAmount] = useState(0);
  const [customTip, setCustomTip] = useState(false);
  const [tipPercentage, setTipPercentage] = useState(0);
  const [tipType, setTipType] = useState(null);
  const [validPromo, setValidPromo] = useState(null);
  const [orderMode, setOrderMode] = useState(null);
  const [payAtStore, setPayAtStore] = useState(false);
  const [selectedShop, setSelectedShop] = useState(null);
  const [tips, setTips] = useState(null);
  const [shopType, setShopType] = useState(null);
  const [splitUpInfo, setSplitUpInfo] = useState(null);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [inventoryOrderGid, setInventoryGid] = useState(null);
  const [dineInNotes, setDineInNotes] = useState('');
  const [enablePromoCode, setEnablePromoCode] = useState(true);

  const quickPayItemDetail = useMemo(() => {
    return [
      {
        quantity: 1,
        itemName: 'QUICK_PAY',
        amount: parseInt((parseFloat(userSetAmount) || 0) * 100, 10),
      },
    ];
  }, [userSetAmount]);

  useEffect(() => {
    if (!shopEntity) return;
    setSelectedAccount(shopEntity.account);
    setOrderMode(shopEntity && shopEntity.orderMode);
    setPayAtStore(shopEntity && shopEntity.enablePayAtStore);
    setSelectedShop(shopEntity.gid);
    setTips(shopEntity.tips);
    setShopType(shopEntity?.shopType);
    setEnablePromoCode(shopEntity?.acceptShopPromo);
  }, [shopEntity]);

  useEffect(() => {
    if (!selectedAccount) return;
    getSplitWithPromo();
  }, [selectedAccount]);

  useEffect(() => {
    handlePaymentPortalInfo({
      inventoryGid: inventoryOrderGid,
      splitUpInfo,
      selectedAccount,
    });    
  }, [
    selectedAccount,
    splitUpInfo,
    inventoryOrderGid,
    handlePaymentPortalInfo,
  ]);

  const getSplitWithPromo = async () => {
    let params;
    if (tipType && tipPercentage) {
      params = {
        shopGid: selectedShop,
        items: quickPayItemDetail,
        tipType: tipType,
        tip: Math.round(tipPercentage * 100),
        promoCode: promoCode,
      }
    } else {
      params = {
        shopGid: selectedShop,
        items: quickPayItemDetail,
        promoCode: promoCode,
      }
    }
    try {
      const { data: { entity } } = await axiosAuthInstance.post(API_END_POINTS.GET_SPLIT_UP, params);
      setSplitUpInfo(entity);
      setPromoMessage(entity.message);
      setValidPromo((entity.message === 'Promo-Code applied') ? true : false);
    } catch (e) {
      console.error(e);
    }
  };

  // const getSplitUpInfo = async (type, amount) => {
  //   let params;
  //   if (type === 'PERCENTAGE') {
  //     setCustomTip(false);
  //   } else if (type === 'AMOUNT') {
  //     setCustomTip(false);
  //   } else {
  //     setCustomTip(false);
  //     setTipPercentage();
  //   }
  //   setTipType(type ?? null);
  //   setTipPercentage(amount ?? 0);
  //   if (type && amount) {
  //     params = {
  //       shopGid: selectedShop,
  //       items: quickPayItemDetail,
  //       tipType: type,
  //       tip: Math.round(amount * 100),
  //     };
  //   } else {
  //     params = {
  //       shopGid: selectedShop,
  //       items: quickPayItemDetail,
  //     };
  //   }
  //   if (promoCode && validPromo) {
  //     params.promoCode = promoCode;
  //   }
  //   try {
  //     const { data: { entity } } = await axiosAuthInstance.post(API_END_POINTS.GET_SPLIT_UP, params);
  //     setSplitUpInfo(entity);
  //   } catch (e) {
  //     console.error(e);
  //   }
  // };

  useEffect(() => {
    if (!paymentAtStoreData) return;
    paymentAtStore(paymentAtStoreData);
  }, [paymentAtStoreData]);

  const paymentAtStore = async (data) => {
    setStatusModalMessage('processing');
    setMessageModalVisible(true);
    setIsProfileVisible(false);
    // let orderMode1;
    // if (Array.isArray(orderMode)
    //   && orderMode?.includes('DINE_IN')
    //   && dineInNotes !== ""
    // ) {
    //   orderMode1 = "DINE_IN"
    // } else if (Array.isArray(orderMode)) {
    //   const filterOrder = orderMode?.filter(item => item !== "DINE_IN")
    //   orderMode1 = filterOrder?.length === 0 ? "DINE_IN" : filterOrder[0]
    // } else {
    //   return;
    // }
    try {
      const payload = {
        mode: 'ONLINE_ORDER', // orderMode1,
        payAtStore: true,
        customer: data,
        note: dineInNotes ? dineInNotes : notes,
        orderType: "WEB",
        redirectUrl: `${redirectUrl}/${slugName}`,
        shopGid: selectedShop,
        totalTip: 0,
        totalTax: Number(splitUpInfo.tax),
        // total: Number(splitUpInfo.netPayable),
        quickPayAmount: parseInt((parseFloat(userSetAmount) || 0) * 100, 10),
        // inventoryOrderLineItems: itemsInfos,
        promoCode: (promoCode && validPromo) ? promoCode : null,
        orderDiscountAmount: Number(splitUpInfo.orderDiscount),
      };
      const { data: { entity } } = await axiosAuthInstance.post(API_END_POINTS.GET_INVENTORY_ORDER, payload);
      const inventOrderGid = entity && entity.gid;
      if (inventOrderGid) {
        history.push(`${PAGES.RECEIPT}/${slugName}?inventId=${inventOrderGid}`);
      }
    } catch (e) {
      console.error(e);
      setStatusModalMessage('failed');
    } finally {
      setTimeout(() => {
        setStatusModalMessage('');
        setMessageModalVisible(false);
      }, 1000);
    }
  }

  const completeOrder = async () => {
    setStatusModalMessage('orderProcessing');
    setMessageModalVisible(true);
    let orderMode1;
    if (Array.isArray(orderMode)
      && orderMode?.includes('DINE_IN')
      && dineInNotes !== ""
    ) {
      orderMode1 = "DINE_IN"
    } else if (Array.isArray(orderMode)) {
      const filterOrder = orderMode?.filter(item => item !== "DINE_IN");
      orderMode1 = filterOrder?.length === 0 ? "DINE_IN" : filterOrder?.[0];
    } else {
      return;
    }
    try {
      const payload = {
        note: dineInNotes ? dineInNotes : notes,
        orderType: "WEB",
        mode: orderMode1,
        redirectUrl: `${redirectUrl}/${slugName}`,
        totalTax: Number(splitUpInfo.tax),
        shopGid: selectedShop, // shopGid,
        totalTip: Number(splitUpInfo.tipAmount),
        // total: Number(splitUpInfo.netPayable),
        quickPayAmount: parseInt((parseFloat(userSetAmount) || 0) * 100, 10),
        // inventoryOrderLineItems: itemsInfos,
        orderDiscountData: null,
        promoCode: (promoCode && validPromo) ? promoCode : null,
        orderDiscountAmount: Number(splitUpInfo.orderDiscount),
      };
      const { data: { entity } } = await axiosAuthInstance.post(API_END_POINTS.GET_INVENTORY_ORDER, payload);
      setInventoryGid(entity.inventoryOrderLink.gid);
      setPaymentPortalModal(true);
    } catch (e) {
      if ((e?.response?.data?.responseCode === 412) 
          && (e.response && e.response?.data?.message?.includes("Not enough stock is available to place item"))
        ) {
        setStatusModalMessage('notEnoughStock');
      }
      console.error(e);
      setStatusModalMessage('failed');
    } finally {
      setTimeout(() => {
        setStatusModalMessage('');
        setMessageModalVisible(false);
      }, 1000);
    }
  };

  return (
    <Col span={24}>
      <Row type="flex" justify="space-between" style={{ padding: '0vw 5vw' }}>
        <Col span={24} className="justify-content-center align-items-center mb-2">
          <SpText fontSize="20px" color="#000000" fontWeight="700" >Your Order</SpText>
        </Col>
      </Row>
      <Row type="flex" justify="space-between" style={{ padding: '0vw 5vw' }}>
        <Col span={12} className="justify-content-center align-items-center mb-2">
          <SpText fontSize="16px" color="#000000" fontWeight="400" >Amount</SpText>
        </Col>
        <Col span={12} className="justify-content-center align-items-center mb-2" style={{ textAlign: 'right' }} >
          <SpText fontSize="16px" color="#000000" fontWeight="400" >{`${currencyType}${userSetAmount}`}</SpText>
        </Col>
      </Row>
      {notes && (
        <Row type="flex" justify="space-between" style={{ padding: '0vw 5vw' }}>
          <Col span={12} className="justify-content-center align-items-center mb-2">
            <SpText fontSize="16px" color="#000000" fontWeight="400" >Notes</SpText>
          </Col>
          <Col span={12} className="justify-content-center align-items-center mb-2" style={{ textAlign: 'right' }} >
            <SpText
              fontSize="16px"
              color="#000000"
              fontWeight="400"
              display='block'
              width='100%'
              whiteSpace='normal'
              wordWrap='break-word'
            >
              {notes}
            </SpText>
          </Col>
        </Row>
      )}
      <hr />
      <div></div>
      <Row>
        {/* <div className="mx-2 my-2 mb-3 px-md-4 px-3 py-2" style={{ borderRadius: '10px', backgroundColor: '#fff' }}> */}
        <div className="w-100">
          {
            (orderMode?.includes('DINE_IN') && shopType === 'KIOSK') ? (
              <Row type="flex" justify="space-between"  style={{ padding: '0vw 5vw' }}>
                <Col span={24} className="justify-content-center align-items-center mb-2">
                  <SpText fontSize="16px" color="#000000" fontWeight="400" style={{ cursor: 'pointer' }} >Table No</SpText>
                </Col>
                <Col span={24} className="justify-content-center align-items-center mb-2">
                  <Row gutter={5} type="flex" justify="space-between">
                    <Col span={18}>
                      <Input value={dineInNotes} type="text" placeholder="Table No" style={{ marginRight: '2%', width: '100%', borderRadius: '6px' }} onChange={(e) => setDineInNotes(e.currentTarget.value)} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            ) : (
              <></>
            )
          }
          {enablePromoCode && (
            <>
              <Row type="flex" justify="space-between" style={{ padding: '0vw 5vw' }}>
                <Col span={24} className="justify-content-center align-items-center mb-2">
                  <SpText fontSize="16px" color="#000000" fontWeight="400" style={{ cursor: 'pointer' }} >Add Promo Code</SpText>
                </Col>
                <Col span={24} className="justify-content-center align-items-center mb-2">
                  <Row gutter={5} type="flex" justify="space-between">
                    <Col span={18}>
                      <Input value={promoCode} type="text" placeholder="Enter Code" style={{ marginRight: '2%', width: '100%', borderRadius: '6px' }} onChange={(e) => { setPromoCode(e.currentTarget.value?.toUpperCase()); setPromoMessage(''); }} />
                    </Col>
                    <Col span={6}>
                      <Button style={{ borderRadius: '10px', border: '1px solid #AEAEAE', background: '#FFFFFF' }} className='searchDateGradientBtn1 w-20' onClick={() => getSplitWithPromo()}>Apply</Button>
                    </Col>
                  </Row>
                </Col>
                {
                  promoCode && promoMessage ? (
                    <Col span={24} className="justify-content-center align-items-center mb-2">
                      <SpText fontSize='16px' color={validPromo ? '#00BA4A' : '#FF0000'}>{promoMessage}</SpText>
                    </Col>
                  ) : (
                    <></>
                  )
                }
              </Row>
              <hr />
              <div>
              </div>
            </>
          )}
          <Row type="flex" justify="space-between" style={{ padding: '0vw 5vw' }}>
            <Col span={24} className="justify-content-center align-items-center mb-2">
              <SpText fontSize="20px" color="#000000" fontWeight="700" >Bill details</SpText>
            </Col>
          </Row>
          <Row type="flex" justify="space-between" style={{ padding: '0vw 5vw' }}>
            <Col span={12} className="justify-content-center align-items-center mb-2">
              <SpText fontSize="16px" color="#000000" fontWeight="400" >Sub total</SpText>
            </Col>
            <Col span={12} className="justify-content-center align-items-center mb-2" style={{ textAlign: 'right' }} >
              <SpText fontSize="16px" color="#000000" fontWeight="400" >$ {splitUpInfo && splitUpInfo.subTotal && (splitUpInfo.subTotal / 100).toFixed(2)}</SpText>
            </Col>
          </Row>
          {
            splitUpInfo && splitUpInfo.orderDiscount ? (
              <Row type="flex" justify="space-between" style={{ padding: '0vw 5vw' }}>
                <Col span={12} className="justify-content-center align-items-center mb-2">
                  <SpText fontSize="16px" color="#000000" fontWeight="400" >Discount</SpText>
                </Col>
                <Col span={12} className="justify-content-center align-items-center mb-2" style={{ textAlign: 'right' }}>
                  <SpText fontSize="16px" color="#FF0000" fontWeight="400" >$ {splitUpInfo && splitUpInfo.orderDiscount && (splitUpInfo.orderDiscount / 100).toFixed(2)}</SpText>
                </Col>
              </Row>
            ) : (
              <></>
            )
          }
          {
            splitUpInfo && splitUpInfo.serviceFee ? (
              <Row type="flex" justify="space-between" style={{ padding: '0vw 5vw' }}>
                <Col span={12} className="justify-content-center align-items-center mb-2">
                  <SpText fontSize="16px" color="#000000" fontWeight="400" >Service Charge</SpText>
                </Col>
                <Col span={12} className="justify-content-center align-items-center mb-2" style={{ textAlign: 'right' }}>
                  <SpText fontSize="16px" color="#000000" fontWeight="400" >$ {splitUpInfo && splitUpInfo.serviceFee && (splitUpInfo.serviceFee / 100).toFixed(2)}</SpText>
                </Col>
              </Row>
            ) : (
              <></>
            )
          }
          {
            splitUpInfo && splitUpInfo.tax ? (
              <Row type="flex" justify="space-between" style={{ padding: '0vw 5vw' }}>
                <Col span={12} className="justify-content-center align-items-center mb-2">
                  <SpText fontSize="16px" color="#000000" fontWeight="400" >Taxes</SpText>
                </Col>
                <Col span={12} className="justify-content-center align-items-center mb-2" style={{ textAlign: 'right' }}>
                  <SpText fontSize="16px" color="#000000" fontWeight="400" >$ {splitUpInfo && splitUpInfo.tax && (splitUpInfo.tax / 100).toFixed(2)}</SpText>
                </Col>
              </Row>
            ) : (
              <></>
            )
          }
          {/* Tipping section */}
          {/* {
            splitUpInfo && splitUpInfo.tipAmount ? (
              <Row type="flex" justify="space-between" style={{ padding: '0vw 5vw' }}>
                <Col span={12} className="justify-content-center align-items-center mb-2">
                  <SpText fontSize="16px" color="#000000" fontWeight="400" >Tip</SpText>
                </Col>
                <Col span={12} className="justify-content-center align-items-center mb-2" style={{ textAlign: 'right' }}>
                  <SpText fontSize="16px" color="#000000" fontWeight="400" >$ {splitUpInfo && splitUpInfo.tipAmount && (splitUpInfo.tipAmount / 100).toFixed(2)}</SpText>
                </Col>
              </Row>
            ) : (
              <Row type="flex" justify="space-between" style={{ padding: '0vw 5vw' }}>
                <Col span={12} className="justify-content-center align-items-center mb-2">
                  <SpText fontSize="16px" color="#000000" fontWeight="400" >Tip</SpText>
                </Col>
                <Col span={12} className="justify-content-center align-items-center mb-2" style={{ textAlign: 'right' }}>
                  <SpText fontSize="16px" color="#000000" fontWeight="400" >$ 0.00</SpText>
                </Col>
              </Row>
            )
          } */}
          {/* <Row type="flex" justify="space-between" style={{ padding: '0vw 5vw' }}>

            <Col span={24} className="justify-content-center align-items-center mb-2">
              <Button className={!tipPercentage && !customTip ? 'searchDateGradientBtn w-20 mt-2' : 'searchDateGradientBtn1 w-20 mt-2'} style={{ marginRight: '2%' }} onClick={() => getSplitUpInfo()}>None</Button>
              {tips?.map((tips) => (
                <Button
                  key={tips.tip}
                  className={tipPercentage === tips.tip && !customTip && tipType === tips.tipType ? 'searchDateGradientBtn w-20 mt-2' : 'searchDateGradientBtn1 w-20 mt-2'}
                  style={{ marginRight: '2%' }}
                  onClick={() => getSplitUpInfo(tips.tipType, tips.tip)}
                >
                  {tips.tipType === "AMOUNT" ? `$${tips.tip}` : `${tips.tip}%`}
                </Button>
              ))}

              <Button className={!tipPercentage && customTip ? 'searchDateGradientBtn w-20 mt-2' : 'searchDateGradientBtn1 w-20 mt-2'} onClick={() => { setCustomTip(!customTip), setTipPercentage() }}>Custom</Button>

            </Col>
            {
              customTip && (
                <Col span={24} className="justify-content-center align-items-center mb-2">
                  <Input
                    placeholder="Enter Tip"
                    style={{ marginRight: '2%', width: '75%' }}
                    value={customTipAmount}
                    prefix="$"
                    // placeholder="0.00"
                    onChange={(e) => {
                      const regex = /^\d*\.?\d*$/;
                      const { value } = e.currentTarget;
                      if (regex.test(value) || value === '') {
                        setCustomTipAmount(e.currentTarget.value);
                      } else if (!regex.test(value)) {
                        setCustomTipAmount(0.00);
                      }
                    }}
                    onKeyPress={e => {
                      const keyCode = e.charCode || e.which;
                      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                        e.preventDefault();
                      }
                    }}
                    onBlur={e => {
                      if (e.currentTarget.value) {
                        const value = formatAmount(e.currentTarget.value, 'US');
                        setCustomTipAmount(value);
                      }
                    }}
                  />
                  <Button className='searchDateGradientBtn1 w-20' onClick={() => getSplitUpInfo('AMOUNT', customTipAmount)}>Add</Button>
                </Col>
              )
            }
          </Row> */}
          <hr />
          <Row type="flex" justify="space-between" style={{ padding: '0vw 5vw' }}>
            <Col span={12} className="justify-content-center align-items-center mb-2">
              <SpText fontSize="16px" color="#000000" fontWeight="700" >Order Total</SpText>
            </Col>
            <Col span={12} className="justify-content-center align-items-center mb-2" style={{ textAlign: 'right' }}>
              <SpText fontSize="16px" color="#000000" fontWeight="700" >$ {splitUpInfo && splitUpInfo.netPayable && (splitUpInfo.netPayable / 100).toFixed(2)}</SpText>
            </Col>
          </Row>
          {
            Array.isArray(orderMode)
            && orderMode.includes('ONLINE_ORDER')
            && payAtStore ? (
              <Row type="flex" justify="space-between" className='mt-2' style={{ padding: '0vw 5vw' }}>
                <Col span={24}>
                  <Button
                    // className='searchDateGradientBtn w-100'
                    // style={{ height: '38px', fontSize: '18px', fontWeight: '500' }}
                    style={{ ...buttonStyle, width: '100%', height: '50px', color: 'white' }}
                    onClick={() => setIsProfileVisible(true)}
                    disabled={!isShopOpen}
                  >
                    Pay at Store
                  </Button>
                </Col>
              </Row>
            ) : (
              <></>
            )
          }
          <Row type="flex" justify="space-between" className='mt-2 mb-5' style={{ padding: '0vw 5vw' }}>
            <Col span={24}>
              <Button
                // className='searchDateGradientBtn w-100'
                // style={{ height: '38px', fontSize: '18px', fontWeight: '500' }}
                style={{ ...buttonStyle, width: '100%', height: '50px', color: 'white' }}
                onClick={() => completeOrder()}
                disabled={!isShopOpen}
              >
                Pay
              </Button>
            </Col>
          </Row>
          <Row type="flex" justify="space-between" className='mt-2' style={{ padding: '0vw 5vw' }}>
            <Col span={24}>
              <span style={{ height: '38px', fontSize: '18px', fontWeight: '500' }}>
                &nbsp;
              </span>
            </Col>
          </Row>
        </div>
      </Row>
    </Col>
  );
};

export default PayScreen;
